<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-lg-12">
                <div class="card-box">
                    <h4 class="header-title">Add E-Money</h4>
                    <p class="sub-header">
                        Fill the form to add
                        <code>E-Money</code>.
                    </p>

                    <div class="col-md-12">

                        <form ref="eMoneyCreate">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>API Partners</label>
                                    <multiselect v-model="eMoney.apiPartnerValue"
                                                 track-by="id"
                                                 label="title"
                                                 placeholder="Select one"
                                                 :options="eMoney.apiPartners"
                                                 deselect-label="Can't remove this value"
                                                 :searchable="true"
                                                 :allow-empty="false">
                                        <template slot="singleLabel" slot-scope="{ option }"> {{ option.title }} </template>
                                    </multiselect>
                                </div>
                                <div class="form-group">
                                    <label>Amount</label>
                                    <input id="amount" v-model="eMoney.amount"
                                           type="number" class="form-control"
                                           :class="{ 'is-invalid': submitted && $v.eMoney.amount.$error }"/>
                                </div>
                                <div class="form-group">
                                    <label>Reference</label>
                                    <textarea id="reference" v-model="eMoney.reference" class="form-control"
                                              :class="{ 'is-invalid': submitted && $v.eMoney.reference.$error }"></textarea>
                                </div>
                            </div>

                        </form>

                        <div class="col-md-6">
                            <div class="form-group">
                                <button type="submit" class="btn btn-primary" @click="submitForm" >Submit</button>
                            </div>
                        </div>

                    </div>
                    <!-- end row -->
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
  import Multiselect from 'vue-multiselect'

  import appConfig from '@src/app.config'
  import Layout from '@layouts/main'
  import PageHeader from '@components/page-header'

  import {
    required,
    numeric,
    minValue,
    maxValue,
  } from 'vuelidate/lib/validators'

  import { eMoneyMethods, apiPartnerMethods } from '@state/helpers'

  /**
   * Advanced-form component
   */
  export default {
    page: {
      title: 'Add E-Money',
      meta: [{ name: 'description', content: appConfig.description }],
    },
    components: {
      Multiselect,
      Layout,
      PageHeader,
    },
    data() {
      return {
        title: 'Add E-Money',
        items: [
          {
            text: '99Gift',
            href: '/',
          },
          {
            text: 'E-Money',
            href: '/',
          },
          {
            text: 'Create E-Money',
            active: true,
          },
        ],
        eMoney : {
          apiPartners: [],
          amount: '',
          reference: '',
          apiPartnerValue: ''
        },
        submitted: false,
      }
    },
    validations: {
      eMoney : {
        amount: { required, numeric,  minValue: minValue(1), maxValue: maxValue(1000000) },
        reference: { required },
        apiPartnerValue: { required }
      },
    },
    async mounted(){

      try{

        const { success, message, data: { result } } = await this.apiPartnerDropDown()

        if(!success) throw Error(message)

        this.eMoney.apiPartners = result;

      }
      catch (e){

        this.appToast('Exception', e.message || 'Error while operating!', 'danger')
      }

    },
    methods : {

      ...eMoneyMethods,
      ...apiPartnerMethods,

      submitForm: async function (event) {

        try{
          this.submitted = true

          this.$v.$touch()
          if (!this.$v.$invalid) {

            const {
              apiPartnerValue,
              amount,
              reference,
            } = this.eMoney;

            const { success, message } = await this.createEMoney({
              apiPartnerValue,
              amount,
              reference
            })

            if(!success) throw Error(message)

            this.$refs.eMoneyCreate.reset()

            this.appToast('E-Money created', message, 'success')
          }
          else{

            if(!this.eMoney.apiPartnerValue){

              this.appToast('Invalid API-Partner', 'Invalid selected API-Partner', 'danger')
            }
          }
        }
        catch (e){

          this.appToast('Exception', e.message || 'Error while operating!', 'danger')
        }
      }
    }
  }
</script>